const info = document.getElementById("heftinfo");
const infolink = document.getElementById("heftinfoLink");

if (info.className === "normal") {
    info.hidden = true;
    infolink.setAttribute("aria-expanded", "false");
}

infolink.addEventListener("click", function(ev) {
    ev.preventDefault();
    info.hidden = !info.hidden;
    infolink.setAttribute("aria-expanded", !info.hidden);
});